/**
 * Created by Mark on 18/04/2017.
 */


import React from 'react';
import { FormattedMessage } from 'react-intl';
import {OverlayTrigger , Tooltip , ControlLabel , Row , Col , FormGroup , FormControl , Table} from 'react-bootstrap';
import DataInput from '../../inputs/date.input.js'
import Select from  'react-select';
import LanguageSelector from "../../inputs/language-selector.js";
import IntelStore from "../../../store/internationalization-store.js"
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import InternationalizationStore from '../../../store/internationalization-store.js';
import LanguageServices from '../../../services/language-services.js';
import LanguageStore from '../../../store/language-store.js';
import Correct from '../../inputs/tickbox.js';
import HomeworkServices from '../../../services/assignment-services.js';

class ContentStep extends React.Component {

    constructor(props){
        super();
        this.props = props;
        this.props.data.language = this.props.data.language || {ietf:false}
        this.state = {};

    }

    componentDidMount() {
        LanguageServices.getAllAvailableLanguages()
    }

    componentWillMount(){
        LanguageStore.on("CHANGE" , () => {

            let languages = LanguageStore.getLearningLanguage();
            this.setState({languages:languages});
        });
    }



    onSelect(language){
        this.props.data.language = language;



        var onLanguageSet = function(){
            this.setState({updated:true});
        };

        if(!this.props.data.homeworkID)
        {
            HomeworkServices.make().then(function(homeworkID){
                this.props.data.homeworkID = homeworkID;
                console.log(this.props.data.homeworkID )
                HomeworkServices.setLanguage(homeworkID , language.ietf).then(onLanguageSet.bind(this))
            }.bind(this))
        }
        else
        {
            HomeworkServices.setLanguage(this.props.data.homeworkID , language.ietf).then(onLanguageSet.bind(this))
        }

        var onLanguageSet = function(){
            this.setState({updated:true});
        };
    }

    render(){


        if(!this.state.languages) return null;


        let languages = this.state.languages.map(function(language){

           // let onClick = !module.catalog_uid  ? this.fetchModules.bind(this , module.screenID , false , Translation.getModuleNoIndexTranslation(module.translationID)) : this.goToCatalog.bind(this , module.catalog_uid);
           // let icon    = !module.catalog_uid  ?  <i className=" zmdi-hc-2x zmdi zmdi-chevron-right"></i> : <i className="zmdi-hc-2x zmdi zmdi-format-list-bulleted"></i>;

            return <Col md={4}>
                <div className="b-1 m-b-10" onClick={this.onSelect.bind(this , language)} >

                    <div  style={{width:'100%' , textAlign:'left'}} className="p-10 vert-center">
                        <h5  style={{margin:0}}> {language.getName()}</h5>
                    </div>
                    <div  style={{width:50}} className="p-10 vert-center">
                        <Correct selected={this.props.data.language.ietf === language.ietf } />
                    </div>
                </div>
            </Col>

        }.bind(this));

        return <div><Row>{languages}</Row></div>
    }
}

export default {
    name: <FormattedMessage id={ 'ui-00' } defaultMessage={ 'Select Language' }/>,
    title:null,
    onLoaded:function(){

    },
    onSubmit: function (done){

        if(!this.props.data.language.ietf)
        {
            done(new Error(IntelStore.getTranslation("ui-673")));
        }
        else
        {
            done();
        }

    },
    component: ContentStep
}


// WEBPACK FOOTER //
// ./src/components/wizard/homework-steps/homework-language.js